import {createSlice} from '@reduxjs/toolkit';
import API from '../../common/api';


export const onboardingSlice = createSlice({
    name: 'onboarding',
    initialState: {
        app_domain: '',
        paymentStatus: null,
        pseudoFlow: false,
        isTrackingDone: false,
        pseudoPhone: '',
        showPaywall: false,
        pseudoInviteLink: '',
        showInviteModal: false,
        offerType: 'fullPrice',
        eventsData: {},
        fbPurchaseData: {}
    },
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setOfferType: (state, action) => {
            state.offerType = action.payload;
        },
        setPaymentStatus: (state, action) => {
            state.paymentStatus = action.payload;
        },
        setUserData: (state, action) => {
            state.userData = action.payload;
        },
        setPseudoFlow: (state, action) => {
            state.pseudoFlow = action.payload;
        },
        setTrackingStatus: (state, action) => {
            state.isTrackingDone = action.payload;
        },
        setPseudoPhone: (state, action) => {
            state.pseudoPhone = action.payload;
        },
        setShowPaywall: (state, action) => {
            state.showPaywall = action.payload;
        },
        setPseudoInviteLink: (state, action) => {
            state.pseudoInviteLink = action.payload;
        },
        setShowInviteModal: (state, action) => {
            state.showInviteModal = action.payload;
        },
        setAppDomain: (state, action) => {
            state.eventsData['app_domain'] = action.payload;
        },
        setEventsData: (state, action) => {
            const {
                // domain,
                // utm,
                // os,
                // email,
                // WhomToLocate,
                // ArriveOrLeave,
                // Following,
                ...purchaseData
            } = action.payload;

            /*state.eventsData = {
                domain,
                utm,
                os,
                email,
                WhomToLocate,
                ArriveOrLeave,
                Following,
            };*/
            Object.assign(state.eventsData,action.payload);
            state.fbPurchaseData = {...purchaseData};
        },
        clearOnboardingData: (state, action) => {
            state.pseudoFlow = false;
            state.paymentStatus = null;
            state.isTrackingDone = false;
            state.showPaywall = false;
            state.pseudoPhone = '';
            state.showInviteModal = false;
            state.pseudoInviteLink = '';
            state.showInviteModal = false;
            state.offerType = '';
        },
    }
});


export const {
    setPaymentStatus,
    setPseudoFlow,
    setTrackingStatus,
    setPseudoPhone,
    setShowPaywall,
    setPseudoInviteLink,
    setShowInviteModal,
    clearOnboardingData,
    setOfferType,
    setEventsData,
    setAppDomain
} = onboardingSlice.actions;

export const generateInviteLink = (token, circleID, phone) => async (dispatch) => {
    const res = await API.getInviteLinkForPhone({token, circleID, phone});
    dispatch(setPseudoInviteLink(res.data.deeplink));
};

export const selectPaymentStatus = state => state.onboarding.paymentStatus;
export const selectPseudoFlow = state => state.onboarding.pseudoFlow;
export const selectTrackingStatus = state => state.onboarding.isTrackingDone;
export const selectPseudoPhone = state => state.onboarding.pseudoPhone;
export const selectSetShowPaywall = state => state.onboarding.showPaywall;
export const selectPseudoInviteLink = state => state.onboarding.pseudoInviteLink;
export const selectShowInviteModal = state => state.onboarding.showInviteModal;
export const selectOfferType = state => state.onboarding.offerType;
export const selectEventsData = state => state.onboarding.eventsData;
export const selectFBPurchaseData = state => state.onboarding.fbPurchaseData;


export default onboardingSlice.reducer;